import type { Job } from "~/types/Job";

/** A job not seen by the scrapers for this long counts as no longer online. */
export const OFFLINE_AFTER_S = 3 * 24 * 60 * 60;

export const isOffline = (
  job: Pick<Job, "lastSeen">,
  nowS: number = Date.now() / 1000,
) => !job.lastSeen || nowS - job.lastSeen > OFFLINE_AFTER_S;

/**
 * Bookmarks split into jobs still online and jobs that are gone, each
 * ordered newest bookmark first.
 */
export function splitSavedJobs<T extends { job: Pick<Job, "lastSeen">; savedAt: number }>(
  saved: T[],
  nowS: number = Date.now() / 1000,
): { active: T[]; inactive: T[] } {
  const newestFirst = [...saved].sort((a, b) => b.savedAt - a.savedAt);
  return {
    active: newestFirst.filter(({ job }) => !isOffline(job, nowS)),
    inactive: newestFirst.filter(({ job }) => isOffline(job, nowS)),
  };
}
